import React from 'react'

/*
 * RouteChunkProgress
 *
 * Lightweight Suspense fallback. Shows a thin 3px gradient bar along
 * the top of the viewport with an indeterminate sliding animation —
 * communicates "something is loading" the way a YouTube or Netflix
 * route change does, without the fullscreen logo + "Personalizing
 * your experience" overlay the old EmptyLoadingScreen rendered.
 *
 * When chunks resolve in under a few hundred milliseconds (the common
 * case on modern networks) the bar barely appears at all; when a
 * chunk is genuinely slow the visitor gets a clear hint without being
 * yanked into a loading screen.
 */

export default function RouteChunkProgress() {
  return (
    <div
      role="status"
      aria-label="Loading"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        zIndex: 10000,
        overflow: 'hidden',
        pointerEvents: 'none',
        background: 'transparent',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: '35%',
          background:
            'linear-gradient(90deg, transparent 0%, #7c3aed 30%, #6366f1 70%, transparent 100%)',
          animation: 'aumhum-route-progress 1.1s ease-in-out infinite',
        }}
      />
      <style>{`
        @keyframes aumhum-route-progress {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        @media (prefers-reduced-motion: reduce) {
          div[role="status"] > div {
            animation: none !important;
            opacity: 0.6;
            transform: translateX(30%);
          }
        }
      `}</style>
    </div>
  )
}
